import {Link} from "react-router-dom";
import setNoIndexMeta from "../components/setNoIndexMeta.tsx";
import setTitleAndMetaDescription from "../components/setTitleAndMetaDescription.tsx";

export default function NotFoundPage(props: {link_back: string, link_title: string}) {
    setNoIndexMeta()
    setTitleAndMetaDescription("Siden findes ikke - Hiper", "Siden du har besøgt findes ikke")

    return (
        <div className={'page-not-found-content'}>
            <h1 className={'heading heading--big heading'}>Hov, siden findes ikke</h1>
            <p className={'align-center'}>
                Siden du har besøgt findes ikke.<br/>
                <Link to={props.link_back}>{props.link_title}</Link>
            </p>
        </div>
    )
}
